import { Icon } from '@orbita-ui/core';
import { StyledAppMenuItem } from './AppMenuItem.styles';
import { useEffect, useState } from 'react';
import { AppSubMenuItem } from './AppSubMenuItem';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppMenuContentProps, SubMenuContentProps } from '../models/MenuContentProps';
import { nanoid } from 'nanoid';

export const AppMenuItem = ({ item }: { item: AppMenuContentProps }) => {
  const [isSubMenuExpanded, setIsSubMenuExpanded] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    const isSelected =
      item.path === pathname ||
      item.subItems?.some((subitem: SubMenuContentProps) => subitem.path === pathname);
    setIsSelected(isSelected);
  }, [pathname, item]);

  const handleItemClick = () => {
    if (item.subItems?.length > 0) {
      // tiene items por lo tanto es un submenu
      setIsSubMenuExpanded((isExpanded) => !isExpanded);
    } else {
      // No tiene items por lo tanto es un link
      navigate(item.path, {
        state: {
          fromMenu: true,
        },
      });
    }
  };

  return (
    <>
      <StyledAppMenuItem $isSelected={isSelected} onClick={() => handleItemClick()}>
        <Icon name={item.iconName} />
        <span>{item.text}</span>
        {item.subItems?.length > 0 && (
          <Icon
            name={isSubMenuExpanded ? 'ChevronUpSmallIcon' : 'ChevronDownSmallIcon'}
          />
        )}
      </StyledAppMenuItem>
      <ul
        style={{
          display: isSubMenuExpanded ? 'initial' : 'none',
        }}
      >
        {item.subItems?.map((subitem) => (
          <AppSubMenuItem key={nanoid()} item={subitem as SubMenuContentProps} />
        ))}
      </ul>
    </>
  );
};
